
import PageScaffolder from '~/components/page-scaffolder';
import CmsBlogFooter from '~/components/cms-blog-footer';
import CmsRelatedArticles from '~/components/cms-related-articles';
import storyblokDatasources from 'mixins/storyblokDatasources';
import { parsePostUrl } from '~/utils/blog';
import GSocialShare from './goose/g-social-share';
import GBreadcrumb from './goose/g-breadcrumb';
import GFooterNewsletterSignup from './goose/g-footer-newsletter-signup';
import GBlogDetailHeader from './goose/g-blog-detail-header';
import GContainer from './goose/g-container';
import GSpacer from './goose/g-spacer';

export default {
  components: {
    PageScaffolder,
    CmsBlogFooter,
    GContainer,
    GFooterNewsletterSignup,
    GSpacer,
    GSocialShare,
    CmsRelatedArticles,
    GBlogDetailHeader,
    GBreadcrumb,
  },
  mixins: [storyblokDatasources],
  props: {
    story: {
      type: Object,
      required: true,
    },
    region: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tags: [],
    };
  },
  computed: {
    slug() {
      return {
        full_slug: parsePostUrl(this.story.full_slug, true),
      };
    },
    socialUrl() {
      return `https://www.deputy.com/${this.slug.full_slug}`;
    },
    newsletterText() {
      return this.interpolateStats(
        'More than ${workplaces} workplaces have used Deputy. Subscribe to learn why.'
      );
    },
  },
  mounted() {
    // we are merging all the tags as we have 4 dropdown in SB
    // features: max 3 displayed
    this.tags = this.story.content.features_tag
      .slice(0, 3)
      .concat(this.story.content.industries_tag, this.story.content.types_tag);
  },
};
